import { MeetingInfo, JoinMeetingResponse } from '../types';

export class ApiService {
  private static baseUrl = '/api/v1';

  static async createMeeting(title?: string, passcode?: string, waitingRoom: boolean = false, hostName?: string, avatarPolicy: string = 'optional') {
    const res = await fetch(`${this.baseUrl}/meetings`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        title: title || 'Untitled Meeting',
        passcode: passcode || '',
        waiting_room: waitingRoom,
        host_name: hostName || '',
        avatar_policy: avatarPolicy,
      }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: 'Failed to create meeting' }));
      throw new Error(err.error || 'Failed to create meeting');
    }

    return await res.json() as {
      room_id: string;
      host_token: string;
      title: string;
      join_url: string;
      created_at: string;
    };
  }

  static async getMeeting(roomId: string): Promise<MeetingInfo> {
    const res = await fetch(`${this.baseUrl}/meetings/${roomId}`);
    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: 'Meeting not found' }));
      throw new Error(err.error || 'Meeting not found');
    }
    return await res.json();
  }

  static async joinMeeting(roomId: string, displayName: string, passcode?: string, hostToken?: string, avatarUrl?: string): Promise<JoinMeetingResponse> {
    const res = await fetch(`${this.baseUrl}/meetings/${roomId}/join`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        display_name: displayName,
        passcode: passcode || '',
        host_token: hostToken || '',
        avatar_url: avatarUrl || '',
      }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: 'Failed to join meeting' }));
      throw new Error(err.error || 'Failed to join meeting');
    }

    return await res.json();
  }

  static async getHealth(): Promise<{ status: string }> {
    const res = await fetch(`${this.baseUrl}/health`);
    return await res.json();
  }
}
